/*
window.onload = function() {

  var CurlType = $.cookie('HairType');
     if (CurlType) {
     alert("you are a '" + CurlType + "' Hair and a returning Customer too");
     }else{
      
alert("you are new visitor");
     }
   
}
*/

function postToGoogle() {
    var field1 = $("input[name='curl-type']:checked").val();
    var field2 = $("input[name='curl-sub-type']:checked").val();
    var field3 = $("input[name='hair-case']:checked").val();

//var CurlType = $.cookie('LUSHairType');

var img = document.createElement("img");
img.setAttribute("src", "https://tags.w55c.net/rs?id=9362012b65e14924a9a494e98045ce4f&t=completed_view");  
img.classList.add('completed-view');
document.body.appendChild(img);
//console.log(img);
var field4 = [];
$.each($("input[name='curl-goals']:checked"), function(){
    field4.push($(this).val());
});
field4 = field4.join(", ");

var field5 = $("input[name='FragranceType']:checked").val();
/**
 * Facebook pixed code - placed here to benefit from the form parsing function
 * Sends the curl quiz data to Facebook after being completed
 * Placed here because want to send curl-goals as an array
 */
fbq('trackCustom',`Quiz`,{
    'quiz-started': 'true',
    'quiz-completed': 'true',
    'curl-type' : field1,
    'curl-sub-type' : field2,
    'hair-case' : field3,
    'curl-goals' : field4,
  'Fragrance-Type' : field5
});
$.cookie("HairType", field1+'-'+field2+'-'+field4+'-'+field5, { expires: 365, path: '/' });

document.getElementById("CT1").innerHTML = $("input[name='curl-sub-type']:checked").val();
document.getElementById("CT2").innerHTML = $("input[name='curl-sub-type']:checked").val();
document.getElementById("CT3").innerHTML = $("input[name='curl-sub-type']:checked").val();
document.getElementById("CT4").innerHTML = $("input[name='curl-sub-type']:checked").val();
document.getElementById("CT5").innerHTML = $("input[name='curl-sub-type']:checked").val();
document.getElementById("CT6").innerHTML = $("input[name='curl-sub-type']:checked").val();
    

$.ajax({
url: "https://docs.google.com/forms/d/e/1FAIpQLScg62BVIc0pVDqlavUQTyY_jFHduNWhqGGnzGb8AW1WhuzVTQ/formResponse?",
        data: {"entry.1018270763": field1, "entry.1354627168": field2, "entry.2006679891": field3, "entry.966184443": field4,"entry.220852905": field5},
type: "POST",
dataType: "xml",
success: function(d)
{
        },
error: function(x, y, z)
            {

                $('#success-msg').show();
                $('#form').hide();
                
            }
    });
    return false;
    
    
}



/*!
* jQuery Cookie Plugin v1.4.1
* https://github.com/carhartl/jquery-cookie
*
* Copyright 2013 Klaus Hartl
* Released under the MIT license
*/
(function (factory) {
if (typeof define === 'function' && define.amd) {
// AMD
define(['jquery'], factory);
} else if (typeof exports === 'object') {
// CommonJS
factory(require('jquery'));
} else {
// Browser globals
factory(jQuery);
}
}(function ($) {

var pluses = /\+/g;

function encode(s) {
return config.raw ? s : encodeURIComponent(s);
}

function decode(s) {
return config.raw ? s : decodeURIComponent(s);
}

function stringifyCookieValue(value) {
return encode(config.json ? JSON.stringify(value) : String(value));
}

function parseCookieValue(s) {
if (s.indexOf('"') === 0) {
// This is a quoted cookie as according to RFC2068, unescape...
s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
}

try {
// Replace server-side written pluses with spaces.
// If we can't decode the cookie, ignore it, it's unusable.
// If we can't parse the cookie, ignore it, it's unusable.
s = decodeURIComponent(s.replace(pluses, ' '));
return config.json ? JSON.parse(s) : s;
} catch(e) {}
}

function read(s, converter) {
var value = config.raw ? s : parseCookieValue(s);
return $.isFunction(converter) ? converter(value) : value;
}

var config = $.cookie = function (key, value, options) {

// Write

if (value !== undefined && !$.isFunction(value)) {
options = $.extend({}, config.defaults, options);

if (typeof options.expires === 'number') {
    var days = options.expires, t = options.expires = new Date();
    t.setTime(+t + days * 864e+5);
}

return (document.cookie = [
    encode(key), '=', stringifyCookieValue(value),
    options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
    options.path    ? '; path=' + options.path : '',
    options.domain  ? '; domain=' + options.domain : '',
    options.secure  ? '; secure' : ''
].join(''));
}

// Read

var result = key ? undefined : {};

// To prevent the for loop in the first place assign an empty array
// in case there are no cookies at all. Also prevents odd result when
// calling $.cookie().
var cookies = document.cookie ? document.cookie.split('; ') : [];

for (var i = 0, l = cookies.length; i < l; i++) {
var parts = cookies[i].split('=');
var name = decode(parts.shift());
var cookie = parts.join('=');

if (key && key === name) {
    // If second argument (value) is a function it's a converter...
    result = read(cookie, value);
    break;
}

// Prevent storing a cookie that we couldn't decode.
if (!key && (cookie = read(cookie)) !== undefined) {
    result[name] = cookie;
}
}

return result;
};

config.defaults = {};

$.removeCookie = function (key, options) {
if ($.cookie(key) === undefined) {
return false;
}

// Must not alter options, thus extending a fresh object...
$.cookie(key, '', $.extend({}, options, { expires: -1 }));
return !$.cookie(key);
};

}));
